import { createBaseHttp } from "./baseHttp";
import { setupInstanceInterceptors } from "../interceptors/instanceInterceptors";

export const createHttpInstance = (opts: {
  baseURL?: string;
  name?: string;
  timeout?: number;
  withCredentials?: boolean;
  defaultHeaders?: Record<string, string>;
}) => {
  const inst = createBaseHttp({
    baseURL: opts.baseURL ?? "http://localhost:7037",
    withCredentials: opts.withCredentials,
    timeout: opts.timeout,
    defaultHeaders: opts.defaultHeaders,
  });
  // attach instance-specific interceptors (e.g., instance-level logging or response shapes)
  setupInstanceInterceptors(
    inst,
    // opts.name ?? "default"
  );
  return inst;
};
